import { supabase } from '@/lib/supabase';

// Direct spreadsheet_rows UPDATEs (the ones that don't go through a
// SECURITY DEFINER RPC) must satisfy the live RLS policy from
// sql/spreadsheets/002_lockdown: `WITH CHECK (updated_by = auth.uid())`.
// There is no trigger that fills updated_by in, so an update that omits it
// is rejected with "new row violates row-level security policy" — for every
// role, SuperAdmin included. Spread rowUpdateStamp() into every direct
// update payload; use setRowClientLink for the client_id join specifically.

/** The columns every direct spreadsheet_rows update must carry. */
export async function rowUpdateStamp(): Promise<{
  updated_by: string | undefined;
  updated_at: string;
}> {
  const { data } = await supabase.auth.getUser();
  return {
    updated_by: data.user?.id,
    updated_at: new Date().toISOString(),
  };
}

/**
 * Set (or clear, with null) spreadsheet_rows.client_id on one row —
 * the canonical clients join every V2 page keys off. Throws on failure.
 */
export async function setRowClientLink(
  rowId: string,
  clientId: string | null
): Promise<void> {
  const { error } = await supabase
    .from('spreadsheet_rows')
    .update({ client_id: clientId, ...(await rowUpdateStamp()) })
    .eq('id', rowId);
  if (error) throw new Error(error.message);
}
